import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect, withRouter } from "react-router-dom";

/**
 * The inverse of ProtectedRoute: a page only a SIGNED-OUT user should see — the
 * login screens.
 *
 * A signed-in user who opens one (typed into the address bar, a bookmark, Back)
 * is sent into the app instead of being shown the login form again. Showing it
 * was not harmless: signing in there as another number silently replaced the
 * session, and every other open tab became that user.
 *
 * <Redirect> REPLACES the history entry, so Back does not land on the login page
 * again. And opening a login URL never ends a session — signing out stays an
 * explicit action (the Logout control).
 */
class GuestRoute extends React.Component {
  render() {
    const { authenticator, redirectTo, ...rest } = this.props;
    if (authenticator()) return <Redirect to={redirectTo} />;
    return <Route {...rest} />;
  }
}

GuestRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.func,
  render: PropTypes.func,
  /** True when a session exists — the same check ProtectedRoute uses. */
  authenticator: PropTypes.func.isRequired,
  /** Where a signed-in user is sent instead. */
  redirectTo: PropTypes.string.isRequired,
};

export default withRouter(GuestRoute);
